import React from 'react';

export const LazySystemSettingPage = React.lazy(() => import('./SystemSettingPage'));
export const LazySystemDashboardPage = React.lazy(() => import('./SystemDashboardPage'));
